import { get, post } from './http';

export interface AdminCmsResponse {
  published: Record<string, any>;
  draft: Record<string, any> | null;
}

const PUBLIC_CMS_CACHE_TTL = 5000;
const publicCmsInFlight = new Map<string, Promise<Record<string, any>>>();
const publicCmsCache = new Map<string, { cachedAt: number; data: Record<string, any> }>();

/**
 * 1. 免鉴权获取已发布页面配置 (前台用户加载)
 */
export function getPublicCms(key: string) {
  const now = Date.now();
  const cached = publicCmsCache.get(key);
  if (cached && now - cached.cachedAt < PUBLIC_CMS_CACHE_TTL) {
    return Promise.resolve(cached.data);
  }

  const inFlight = publicCmsInFlight.get(key);
  if (inFlight) return inFlight;

  const req = get<Record<string, any>>(`/public/cms/${key}`)
    .then((res) => {
      publicCmsCache.set(key, { cachedAt: Date.now(), data: res });
      return res;
    })
    .finally(() => {
      publicCmsInFlight.delete(key);
    });

  publicCmsInFlight.set(key, req);
  return req;
}

/**
 * 2. 管理员获取页面草稿及已发布内容
 */
export function getAdminCms(key: string) {
  return get<AdminCmsResponse>(`/admin/cms/${key}`);
}

/**
 * 3. 保存页面草稿到数据库
 */
export function saveAdminCmsDraft(key: string, draftJson: Record<string, any>) {
  return post<{ message: string }>(`/admin/cms/${key}/draft`, { draftJson });
}

/**
 * 4. 确认发布页面内容到数据库
 */
export function publishAdminCms(key: string, publishedJson: Record<string, any>) {
  return post<{ message: string }>(`/admin/cms/${key}/publish`, { publishedJson });
}
